module.exports = __webpack_public_path__ + "static/media/calendaoff.bc98c6bd.svg";